// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3QuEp","title":"ClientCherryInfo_title__1dGNs","itemText":"ClientCherryInfo_itemText__5xY6x"};